import StartDateTimeStage from
  'Pages/AppointmentRequestWidget/stages/StartDateTimeStage';
import { ThemeUIProvider } from 'theme-ui';
import { ConfigProvider } from 'antd';
import { AntdConfigProviderTheme } from 'Common/functions/antdTheme';
import theme from 'Common/theme';
import RequestAppointmentSummary from '../RequestAppointmentSummary';
import { GetServiceOfferingWithCustomerInputs } from 'Common/functions/getServiceOfferingWithCustomerInputs';
import { GetLocationById } from 'Common/functions/getLocationById';
import { GetServiceProviderWithAvailability } from 'Common/functions/getServiceProviderWithAvailability';
import { GetBookingCartByUid } from 'Common/functions/getBookingCartByUid';

type StartDateTimePageContentProps = {
  location: Pick<NonNullable<GetLocationById>, 'uid' | 'type'> | null | undefined;
  startDateTime: number | undefined;
  serviceOffering: Pick<GetServiceOfferingWithCustomerInputs, 'customerInputs' | 'basePrice' | 'baseTime' | 'title' | 'type'> | undefined;
  durationSeconds: number;
  totalPrice: number | null;
  selectedServiceAreaUid: string | undefined | null;
  onServiceAreaSelect?: (newServiceAreaUid: string) => void;
  availabilityNode: React.ReactNode;
  serviceProvider: Pick<GetServiceProviderWithAvailability, 'displayName' | 'preferences' | 'profile' | 'serviceType'>;
  bookingCart: GetBookingCartByUid | undefined;
  durationCopy: string | undefined;
  nextButton: React.ReactNode;
  renderPrice?: (price: number) => React.ReactNode;
  precontent?: React.ReactNode;
  locationNode?: React.ReactNode;
  hidePrice?: boolean;
}

const StartDateTimePageContent: React.FC<StartDateTimePageContentProps> = ({
  location,
  startDateTime,
  serviceOffering,
  durationSeconds,
  totalPrice,
  selectedServiceAreaUid,
  onServiceAreaSelect,
  availabilityNode,
  serviceProvider,
  bookingCart,
  durationCopy,
  nextButton,
  renderPrice,
  precontent,
  locationNode,
  hidePrice = false,
}) => {
  return (
    <>
      <div
        className="flex flex-col col-span-4 h-full md:border-solid md:border-r-gray-300 md:border-r-[1px] md:mr-8 md:pr-8 gap-y-8"
      >
        {precontent}
        <div
          className="flex flex-col items-center "
        >
          <ThemeUIProvider theme={theme}>
            <ConfigProvider theme={AntdConfigProviderTheme}>
              {location && serviceOffering && (
                <StartDateTimeStage
                  location={location}
                  serviceAreaUid={selectedServiceAreaUid}
                  onServiceAreaSelect={onServiceAreaSelect}
                  serviceProviderAvailabilityNode={availabilityNode}
                />
              )}
            </ConfigProvider>
          </ThemeUIProvider>
        </div>
      </div>

      <div className="sm:col-span-4 md:col-span-2 sm:w-full md:w-3/4">
        <RequestAppointmentSummary
          serviceOffering={serviceOffering}
          subTotalPrice={totalPrice}
          subTotalPriceAfterDiscounts={null}
          hidePrice={hidePrice}
          serviceProviderDisplayName={serviceProvider?.displayName}
          serviceProviderAvatarImageUrl={serviceProvider?.profile?.avatarImage?.uploadedFile.publicUrl}
          serviceType={serviceProvider?.serviceType}
          customerInputSelections={bookingCart?.bookingSelections.customerInputSelections}
          locationStreetAddress={undefined}
          startDateTime={startDateTime}
          tipPercent={null}
          suffix={durationCopy}
          renderSubtotalPrice={renderPrice}
          totalDurationMins={durationSeconds / 60}
          locationNode={locationNode}
        />
        {nextButton}
      </div>
    </>
  );
};

export default StartDateTimePageContent;
